/**
 * Group detail Mode B — layout only (visuals from CC glass in 22-overview-command-center.css).
 */

export const GROUP_DETAIL_STYLE_ID = "croc-group-detail-mode-b-v4";

const GROUP_DETAIL_STYLE_TEXT = `
.grp-mode-b-page {
  display: flex;
  flex-direction: column;
  gap: var(--cc-gap, 14px);
  width: 100%;
}
.grp-mode-b {
  display: grid;
  grid-template-columns: minmax(240px, 20%) minmax(0, 1fr) minmax(260px, 22%);
  gap: var(--cc-gap, 14px);
  min-height: calc(100dvh - 168px);
  align-items: stretch;
}
.grp-mode-b__left-col {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  min-width: 0;
}
.grp-mode-b__left,
.grp-mode-b__devices,
.grp-mode-b__right {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 14px 16px;
}
.grp-mode-b__left {
  flex: 1 1 auto;
}
.grp-mode-b__devices {
  flex: 0 0 auto;
}
.grp-sidebar-devices-head {
  margin-bottom: 12px;
}
.grp-sidebar-panel-head {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.grp-sidebar-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin-top: 4px;
  padding-right: 2px;
}
.grp-sidebar-section {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.grp-sidebar-section--groups {
  flex: 1 1 auto;
  min-height: 0;
}
.grp-sidebar-section--all-devices {
  flex-shrink: 0;
}
.grp-sidebar-section__title {
  margin: 0 0 10px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cc-text-muted, #64748b);
}
.grp-sidebar-section__title--all-devices {
  margin-bottom: 12px;
  color: var(--cc-text, #0f172a);
  letter-spacing: 0.1em;
}
.grp-sidebar-section--groups .grp-sidebar-section__title {
  margin-top: 4px;
}
.grp-sidebar-share-actions {
  flex-shrink: 0;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(148, 163, 184, 0.22);
}
.grp-mode-b__center-stack {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  min-height: 0;
}
.grp-mode-b__head { margin-bottom: 8px; }
.grp-sidebar-scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 2px;
}
.grp-sidebar-all-devices {
  flex-shrink: 0;
  padding: 14px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.42);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55), 0 8px 24px rgba(15, 23, 42, 0.06);
}
.grp-sidebar-all-devices .grp-sidebar-item--all {
  margin: 0;
  padding: 0;
  border: none;
}
.grp-sidebar-all-devices .grp-sidebar-item--all .grp-sidebar-card {
  border-radius: 12px;
  padding: 12px 10px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.2);
}
.grp-sidebar-all-devices .grp-sidebar-item--all .grp-sidebar-card--active {
  border-color: rgba(37, 99, 235, 0.45);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.14), 0 6px 18px rgba(59, 130, 246, 0.12);
}
.grp-sidebar-all-devices .grp-sidebar-item--all .croc-cc-zone__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
}
.grp-sidebar-create { width: 100%; margin-bottom: 12px; justify-content: center; }
.grp-mode-b__hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
}
.grp-mode-b__hero-main { display: flex; gap: 14px; align-items: flex-start; min-width: 0; flex: 1; }
.grp-mode-b__hero-icon {
  width: 56px; height: 56px; border-radius: 16px;
  background: linear-gradient(135deg, #2563eb, #6366f1);
  color: #fff; font-size: 22px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.28);
}
.grp-mode-b__hero-copy { min-width: 0; flex: 1; }
.grp-mode-b__hero-title-row { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-bottom: 10px; }
.grp-mode-b__hero-title { margin: 0; font-size: 1.45rem; font-weight: 700; color: var(--cc-text, #0f172a); }
.grp-mode-b__status-badge { font-size: 11px; }
.grp-mode-b__meta-grid {
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px 14px;
}
.grp-meta-item { min-width: 0; }
.grp-meta-item__lbl {
  display: block; font-size: 10px; font-weight: 600; letter-spacing: 0.05em;
  text-transform: uppercase; color: var(--cc-text-muted, #64748b); margin-bottom: 2px;
}
.grp-meta-item strong { font-size: 13px; color: var(--cc-text, #0f172a); }
.grp-meta-val--ok { color: var(--cc-success, #15803d) !important; }
.grp-mode-b__response-card {
  display: flex; flex-direction: column; gap: 6px; align-items: flex-start;
  padding: 14px 16px; min-width: 180px;
}
.grp-mode-b__response-val { font-size: 15px; color: var(--cc-text, #0f172a); font-weight: 700; }
.grp-mode-b__tabs {
  display: flex; flex-wrap: wrap; gap: 6px; padding: 6px;
}
.grp-mode-b__tab {
  padding: 10px 14px; border: none; border-radius: 12px;
  background: transparent; font-family: inherit;
  font-size: 13px; font-weight: 600; color: var(--cc-text-muted, #64748b); cursor: pointer;
  transition: var(--cc-transition, 0.2s ease);
}
.grp-mode-b__tab:hover {
  background: rgba(59, 130, 246, 0.08);
  color: var(--cc-primary, #2563eb);
}
.grp-mode-b__tab--active {
  color: var(--cc-primary, #2563eb);
  background: rgba(59, 130, 246, 0.12);
  box-shadow: inset 0 -2px 0 var(--cc-primary, #2563eb);
}
.grp-mode-b__panels { min-height: 0; }
.grp-mode-b__panel { display: flex; flex-direction: column; gap: 12px; }
.grp-mode-b__panel[hidden] { display: none !important; }
.grp-map-wrap { position: relative; overflow: hidden; min-height: 380px; padding: 0 !important; }
.grp-map-wrap--solo { min-height: 520px; }
.grp-map-canvas { width: 100%; height: 100%; min-height: 380px; background: #1e293b; border-radius: inherit; }
.grp-map-wrap--solo .grp-map-canvas { min-height: 520px; }
.grp-map-toolbar {
  position: absolute; top: 12px; left: 12px; z-index: 2;
  display: flex; flex-wrap: wrap; gap: 8px; align-items: center;
  padding: 8px 12px; font-size: 11px;
}
.grp-map-toolbar__label { font-weight: 700; color: var(--cc-text-muted, #64748b); margin-right: 4px; }
.grp-map-toggle { display: flex; align-items: center; gap: 4px; color: var(--cc-text, #0f172a); }
.grp-map-donut {
  position: absolute; bottom: 16px; left: 16px; z-index: 2;
  width: 92px; height: 92px; border-radius: 50%;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.grp-map-donut__pct { font-size: 18px; font-weight: 700; color: var(--cc-success, #15803d); }
.grp-map-donut__lbl { font-size: 10px; color: var(--cc-text-muted, #64748b); }
.grp-mode-b__section-title {
  margin: 0 0 8px; font-size: 0.72rem; font-weight: 700;
  letter-spacing: 0.06em; text-transform: uppercase; color: var(--cc-text-muted, #64748b);
}
.grp-mode-b__devices-scroll {
  flex: 1 1 auto; min-height: 0; overflow: auto; padding-right: 4px;
}
.grp-device-grid { display: grid; gap: 8px; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }
.grp-devices-panel,
.grp-members-panel,
.grp-rules-panel,
.grp-activity-panel { padding: 14px 16px; }
.grp-action-list { display: flex; flex-direction: column; gap: 8px; }
.grp-action-btn {
  display: flex; align-items: center; gap: 8px; width: 100%;
  justify-content: flex-start; text-align: left;
}
.grp-members-list { display: flex; flex-direction: column; gap: 8px; }
.grp-activity-scroll {
  max-height: 220px; overflow: auto;
  display: flex; flex-direction: column; gap: 8px;
}
.grp-activity-scroll--bottom { max-height: 180px; }
.grp-activity-scroll--full { max-height: none; min-height: 320px; }
.grp-ai-body { font-size: 13px; line-height: 1.45; min-height: 48px; margin-top: 10px; }
.grp-empty-hint { margin: 0; font-size: 12px; color: var(--cc-text-muted, #64748b); }
.grp-mode-b__bottom {
  display: grid; grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px; padding: 16px 18px;
}
.grp-bottom-panel { min-width: 0; }
.grp-info-list { margin: 0; font-size: 12px; }
.grp-info-list div { display: grid; grid-template-columns: 88px 1fr; gap: 8px; padding: 4px 0; }
.grp-info-list dt { margin: 0; color: var(--cc-text-muted, #64748b); }
.grp-info-list dd { margin: 0; color: var(--cc-text, #0f172a); }
.grp-quick-stats {
  display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 8px; margin-bottom: 8px;
}
@media (max-width: 1200px) {
  .grp-mode-b { grid-template-columns: 1fr; min-height: auto; }
  .grp-mode-b__meta-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .grp-mode-b__bottom { grid-template-columns: 1fr; }
  .grp-quick-stats { grid-template-columns: repeat(2, 1fr); }
}
.grp-all-devices-bulk {
  margin-bottom: 12px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.grp-all-devices-bulk__actions {
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.grp-all-devices-bulk__details {
  min-width: 260px;
  flex: 1 1 420px;
}
.grp-mode-b--all-fleet {
  grid-template-columns: minmax(240px, 20%) minmax(0, 1fr);
}
.grp-mode-b--hub-directory {
  grid-template-columns: minmax(240px, 20%) minmax(0, 1fr);
}
.grp-hub-directory {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  padding: 24px 28px;
  gap: 12px;
}
.grp-hub-directory__head {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.grp-hub-directory__copy { min-width: 0; }
.grp-hub-directory__lead {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.55;
  max-width: 52ch;
}
.grp-hub-directory__lead a {
  color: var(--cc-accent, #38bdf8);
  text-decoration: none;
}
.grp-hub-directory__lead a:hover { text-decoration: underline; }
.grp-mode-b__center-stack--hub-directory {
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.grp-all-devices-fleet {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
  padding: 16px 18px;
  gap: 12px;
}
.grp-all-devices-fleet__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 16px;
}
.grp-all-devices-fleet__title-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  min-width: 0;
  flex: 1 1 280px;
}
.grp-all-devices-fleet__icon {
  background: linear-gradient(135deg, #0ea5e9, #6366f1);
  flex-shrink: 0;
}
.grp-all-devices-fleet__copy { min-width: 0; }
.grp-all-devices-fleet__lead { margin: 6px 0 0; font-size: 13px; }
.grp-all-devices-fleet__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.grp-all-devices-fleet__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}
.grp-mode-b__center-stack--all-fleet {
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}
.grp-all-devices-bulk-mount[hidden] { display: none !important; }
.grp-sidebar-item--all .croc-cc-zone__icon {
  font-size: 14px;
  font-weight: 700;
}
`;

/** @returns {boolean} */
export function ensureGroupDetailStyles() {
  if (typeof document === "undefined") return false;
  if (document.getElementById(GROUP_DETAIL_STYLE_ID)) return true;
  const el = document.createElement("style");
  el.id = GROUP_DETAIL_STYLE_ID;
  el.textContent = GROUP_DETAIL_STYLE_TEXT;
  document.head.appendChild(el);
  return true;
}

export function removeGroupDetailStyles() {
  if (typeof document === "undefined") return;
  const el = document.getElementById(GROUP_DETAIL_STYLE_ID);
  if (el) el.remove();
}
